var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.2,
    height: 88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#f64c71}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M43 31.4c.1-1.4-1-2.6-2.3-2.6h-.2c-1.3 0-2.4 1-2.5 2.3l-.5 5.9c-.2 3 1.1 6 3.6 7.8 1 .7 2.1 1.2 3.3 1.5l7.7 1.6c.4.1.8-.2.9-.6.1-.4-.2-.8-.6-.9l-1.2-.3c-5.3-1.5-8.8-6.5-8.4-12l.2-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    transform: "rotate(-45.001 68.2 47.67)",
    className: "st0",
    d: "M65.1 46.2h6.2v2.9h-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    transform: "rotate(-75.965 71.868 55.005)",
    className: "st0",
    d: "M70.4 52h2.9v6h-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M72.6 81.8l-4.8-1.6c-1.1-.4-1.9-1.4-2-2.6L65 62.3c-.3-5.9-4.2-11.1-9.8-13.1-.7.9-1.8 1.5-3 1.5-.3 0-.5 0-.8-.1L43.7 49c-1.6-.3-3.1-1-4.4-2-3.3-2.4-5.1-6.4-4.8-10.4l.5-5.9c.3-2.9 2.8-5.1 5.7-5 3 .2 5.3 2.8 5.1 5.8l-.2 2.6c-.1 1.2.1 2.5.6 3.6.4-.5.9-1.1 1.4-1.7.8-1 1.6-1.9 2-2.5 2.1-3.1 2.4-7 .8-10.3C57 22 61.2 15.9 59.9 9.5 58.7 3.1 52.5-1 46.2.2S35.6 7.6 36.9 14c.2 1.2.6 2.3 1.2 3.4-.8.2-1.7.6-2.4 1l-.4.2c-7.4 4-12.7 11.1-14.5 19.3l-2.6 11.5c-.6 3.4.5 6.9 2.9 9.3H10.3v-4.4h1.5c.8 0 1.5-.7 1.5-1.5V14.7c0-.8-.7-1.5-1.5-1.5H1.5c-.8 0-1.5.7-1.5 1.5v38.1c0 .8.7 1.5 1.5 1.5H3v4.4H1.5c-.8 0-1.5.7-1.5 1.5v7.3c0 .8.7 1.5 1.5 1.5H3v17.6c0 .8.7 1.5 1.5 1.5h4.4c.8 0 1.5-.7 1.5-1.5V68.9h24.9v17.6c0 .8.7 1.5 1.5 1.5h4.4c.8 0 1.5-.7 1.5-1.5V68.9H44c.8 0 1.5-.7 1.5-1.5v-5.9h6.3c.7 0 1.3.5 1.4 1.2l3.6 21.5c.3 2.1 2.2 3.7 4.3 3.7h10.5c1.8 0 3.2-1.4 3.2-3.2 0-1.2-.9-2.4-2.2-2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.0982e6873cfe3577ad7ad51a780b019a.svg";
export { ForwardRef as ReactComponent };